import { createFileRoute, Link } from '@tanstack/react-router'
import NewsletterComponent from "../../../components/Common/Newsletter"
import { Container, Text, useToken } from '@chakra-ui/react'
import NotFound from '../../../components/Common/NotFound'

export const Route = createFileRoute('/_layout/newsletter/')({
  component: Newsletter,
  notFoundComponent: NotFound,
})

function Newsletter() {
  const [main] = useToken("colors", ["main"])
  
  return (
    <>
        <NewsletterComponent/>
        <Container textAlign="center">
          <Text>Vom Newsletter <Link to="/newsletter/abmelden" style={{color: main, textDecoration: "underline"}} >abmelden</Link></Text>
        </Container>
    </>
  )
}
